<!-- Quick Actions Wrapper with border -->
<div class="quick-actions-wrapper">
  <!-- Quick Actions Bar Container -->
  <div
    class="quick-actions-bar"
    [class.horizontal]="displayMode === 'horizontal'"
    [class.vertical]="displayMode === 'vertical'"
    [class.compact]="compact"
    [class.loading]="loading"
    [class.filter-style]="filterStyle"
  >
    <!-- Edit Button FIRST (List view only, controlled by showEditButton) -->
    @if (showEditButton) {
      <p-button
        icon="pi pi-pencil"
        [label]="compact ? '' : 'Edit'"
        severity="secondary"
        [text]="true"
        size="small"
        [disabled]="loading"
        (onClick)="onEdit()"
        pTooltip="Edit Scheduled Order"
        tooltipPosition="top"
        styleClass="action-button edit-action"
      />
    }

    <!-- Status-Based Action: Pause or Activate -->
    @if (shouldShowPause() || shouldShowActivate()) {
      <p-button
        [icon]="getStatusActionIcon()"
        [label]="compact ? '' : getStatusActionLabel()"
        [severity]="getStatusActionSeverity()"
        [text]="true"
        size="small"
        [disabled]="loading"
        [loading]="loading"
        (onClick)="shouldShowPause() ? onPause() : onActivate()"
        [pTooltip]="getStatusActionLabel()"
        tooltipPosition="top"
        styleClass="action-button status-action"
      />
    }

    <!-- Retry Button (Failed orders only) - MUST come before Process Now -->
    @if (shouldShowRetry()) {
      <p-button
        icon="pi pi-replay"
        [label]="compact ? '' : 'Retry'"
        severity="danger"
        [text]="true"
        size="small"
        [disabled]="loading"
        [loading]="loading"
        (onClick)="onRetry()"
        pTooltip="Retry Processing"
        tooltipPosition="top"
        styleClass="action-button retry-action"
      />
    }

    <!-- Process Now Button (Active, Paused, and Failed orders) -->
    @if (showProcessNowButton && isProcessNowEnabled()) {
      <p-button
        icon="pi pi-bolt"
        [label]="compact ? '' : 'Process'"
        severity="info"
        [text]="true"
        size="small"
        [disabled]="loading"
        [loading]="loading"
        (onClick)="onProcessNow()"
        pTooltip="Process Now"
        tooltipPosition="top"
        styleClass="action-button process-action"
      />
    }

    <!-- Reschedule Button (Active, Failed, Paused orders) -->
    @if (shouldShowReschedule()) {
      <p-button
        icon="pi pi-calendar"
        [label]="compact ? '' : 'Reschedule'"
        severity="help"
        [text]="true"
        size="small"
        [disabled]="loading"
        [loading]="loading"
        (onClick)="onReschedule()"
        pTooltip="Reschedule Order"
        tooltipPosition="top"
        styleClass="action-button reschedule-action"
      />
    }

    <!-- Cancel/Delete Button (Active, Failed, Paused only) -->
    @if (shouldShowDelete()) {
      <p-button
        icon="pi pi-times"
        [label]="compact ? '' : 'Cancel/Delete'"
        severity="danger"
        [text]="true"
        size="small"
        [disabled]="loading"
        [loading]="loading"
        (onClick)="onDelete()"
        pTooltip="Cancel/Delete Order"
        tooltipPosition="top"
        styleClass="action-button delete-action"
      />
    }
  </div>
</div>
